var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-testid":"patient-dashboard"}},[_vm._t("default",null,{"indicationHistoryAmount":_vm.indicationHistoryAmount,"openNotesModal":_vm.openNotesModal,"setIndicationHistoryAmount":_vm.setIndicationHistoryAmount})],2)}
var staticRenderFns = []

export { render, staticRenderFns }